var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wkb-menubar" }, [
    _c(
      "div",
      { staticClass: "wkb-menu-group wkb-menu-group-left" },
      _vm._l(_vm.menus, function (menu) {
        return _c(
          "b-dropdown",
          {
            key: menu.id,
            staticClass: "wkb-menu",
            attrs: {
              text: menu.label,
              variant: "outline-secondary",
              size: "sm",
              "menu-class": "wkb-menu-list",
              "toggle-class": "wkb-menu-toggle",
            },
          },
          _vm._l(menu.items, function (item) {
            return _c(
              "b-dropdown-item",
              {
                key: item.id,
                on: {
                  click: function ($event) {
                    return _vm.onSelect(menu, item)
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.label) + " ")]
            )
          }),
          1
        )
      }),
      1
    ),
    _c(
      "div",
      { staticClass: "wkb-menu-group wkb-menu-group-right" },
      [
        _c(
          "b-button",
          {
            staticClass: "wkb-library-button",
            attrs: { variant: "outline-secondary", size: "sm" },
            on: { click: _vm.onLibrary },
          },
          [_vm._v(" " + _vm._s(_vm.libraryMenu.label) + " ")]
        ),
        _c(
          "b-dropdown",
          {
            staticClass: "wkb-menu wkb-help-menu",
            attrs: {
              text: "Help",
              variant: "outline-secondary",
              size: "sm",
              "menu-class": "wkb-menu-list",
              "toggle-class": "wkb-menu-toggle",
            },
          },
          [
            _c("b-dropdown-item", { on: { click: _vm.onHelpLearnCanvas } }, [
              _vm._v(" Learn Canvas "),
            ]),
            _c("b-dropdown-item", { on: { click: _vm.onHelpDocumentation } }, [
              _vm._v(" Documentation "),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }